<app-menu></app-menu>
<app-login-validation (loggedIn)="onLoginValidated($event)"></app-login-validation>

<div class="print-container">
  <div class="container">
    <h1>O seu livro está pronto para publicar</h1>
    <p>
      Parabéns! Seu livro está pronto para publicação. Preparamos tudo para que você comece a vendê-lo agora mesmo.
    </p>
    <ng-container *ngIf="isLoading; else mainContent">
      <div class="spinner-container">
        <mat-spinner></mat-spinner>
      </div>
    </ng-container>
    <ng-template #mainContent>

      <h2 class="cost-title">Custo estimado para produzir o seu livro</h2>

      <form [formGroup]="model">
        <div class="form-section">
          <h3 class="section-subtitle">Tamanho</h3>

          <div class="formats-grid">
            <div class="format-card" *ngFor="let group of groupedPrints"
              [ngClass]="{'selected': selectedSizeGroup?.size === group.size}" (click)="selectSizeGroup(group)">
              <div class="format-icon">
                <mat-icon>aspect_ratio</mat-icon>
              </div>
              <div class="format-name">{{ group.size }}</div>
              <div class="format-desc">{{ group.variations.length }} {{ group.variations.length === 1 ? 'variação' :
                'variações' }}</div>
            </div>
          </div>
        </div>

        <div class="form-section" *ngIf="selectedSizeGroup">
          <h3 class="section-subtitle">Variação de impressão</h3>

          <div class="formats-grid variations-grid">
            <div class="format-card variation-card" *ngFor="let print of selectedSizeGroup.variations"
              [ngClass]="{'selected': selectedPrint?.idBookPrint === print.idBookPrint}" (click)="selectPrint(print)">
              <div class="format-name variation-name">{{ print.bookPrintDescription }}</div>
              <div class="format-price text-success">R$ {{ print.rawUnitCost.toFixed(2) }}</div>
            </div>
          </div>
        </div>
      </form>

      <p class="info-note">
        Escolha o material que melhor se adequa ao conteúdo do seu livro e ao público-alvo. Lembre-se: o custo de
        produção
        impacta sua margem de lucro, portanto, pense com cuidado na sua estratégia de precificação.
      </p>

      <div class="print-actions">
        <button class="back-btn" (click)="voltar()">Voltar</button>
        <button class="continue-btn" [disabled]="model.invalid" (click)="publicarAgora()">Publicar agora</button>
      </div>
    </ng-template>
  </div>
</div>

<app-footer></app-footer>